export const authRole = {
    SUPER_ADMIN: ["SUPER-ADMIN"],
    ADMIN: ["ADMIN"],
    USER: ["USER"],
    MANAGER: ["MANAGER"],
    LOCATION_MANAGER: ["LOCATION-MANAGER"],
    FINANCE_MANAGER: ["FINANCE-MANAGER"],
    HR_MANAGER: ["HR-MANAGER"],
    MEMBER: ["MEMBER"],
    FRONTDESK: ["FRONT-DESK"],
    DOCTOR: ["DOCTOR"],
    KITCHEN: ["KITCHEN"],
    ACCOMODATION: ["ACCOMODATION"],
    SETUP_MANAGER: ["SETUP-MANAGER"],
};

export const RoutePermittedRole = {
    SUPER_ADMIN: "SUPER-ADMIN",
    ADMIN: "ADMIN",
    USER: "USER",
    MANAGER: "MANAGER",
    LOCATION_MANAGER: "LOCATION-MANAGER",
    FINANCE_MANAGER: "FINANCE-MANAGER",
    HR_MANAGER: "HR-MANAGER",
    MEMBER: "MEMBER",
    FRONTDESK: "FRONT-DESK",
    DOCTOR: "DOCTOR",
    KITCHEN: "KITCHEN",
    ACCOMODATION: "ACCOMODATION",
    SETUP_MANAGER: "SETUP-MANAGER",
};
export const isCheckRoleMatched = ["FINANCE-MANAGER"];
export const isCheckAttendenceRole = ["HR-MANAGER", "ADMIN"];
export const isCheckManagerRole = ["MANAGER"];
export const defaultUser = {
    displayName: "John Alex",
    email: "demo@example.com",
    token: "access-token",
    role: "user",
    photoURL: "/assets/images/avatar/A11.jpg",
};

// ===========================
// LOCAL
// ===========================
// export const baseURL = "http://192.168.60.65:8766";
 //export const baseURLAuth = "http://192.168.80.169:8765";

// ===========================
// DEVELOPMENT
// ===========================
// export const baseURL = "http://3.111.162.16:8762/api";
//  export const baseURLAuth = "http://3.111.162.16:8762/api/auth";

// ===========================
// PRODUCTION
// ===========================
// export const baseURL = "http://3.111.162.16:8762/api";
export const baseURL = "https://dhamwasi.bgsm.org/api";
export const baseURLAuth = "https://dhamwasi.bgsm.org/api/auth";

export const initialUrl = "/dashboard"; // this url will open after login

export const ROW_PER_PAGE = 10;
export const TOAST_TIMEOUT = 2000;

export const ISSUE_REPORT_TYPE = [
    {
        value: "CATEGORY_WISE_ISSUE_REPORT",
        label: "Category wise issue report",
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "PRIORITY_WISE_PENDING_ISSUE_REPORT",
        label: "Priority wise pending issue report",
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "DELAYED_ISSUE_REPORT",
        label: "Delayed issue report",
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "LOCATION_WISE_ISSUE_REPORT",
        label: "Location wise issue report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
];
export const ATTENDANCE_REPORT_TYPE = [
    {
        value: "INDIVIDUAL_ASHRAMWASI_ATTENDANCE_REPORT",
        label: "Individual ashramwasi attendance report",
        permittedRole: [RoutePermittedRole.MEMBER],
    },
    {
        value: "LOCATION_WISE_PRESENT_REPORT",
        label: "Location wise present report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "LOCATION_WISE_ABSENT_REPORT",
        label: "Location wise absent report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "LATE_ARRIVAL_REPORT",
        label: "Late arrival report",
        permittedRole: [
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "OVERTIME_REPORT",
        label: "Overtime report",
        permittedRole: [
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "ABSENSE_BY_DEPARTMENT_TEAM_REPORT",
        label: "Absense by department team report",
        permittedRole: [
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    // {
    //     value: "WEEKLY_SUMMARY_REPORT",
    //     label: "Weekly summary report",
    //     permittedRole: [
    //         RoutePermittedRole.HR_MANAGER,
    //         RoutePermittedRole.ADMIN,
    //         RoutePermittedRole.SUPER_ADMIN,
    //     ],
    // },
];
export const LEAVE_REPORT_TYPE = [
    {
        value: "LEAVE_SUMMARY_REPORT",
        label: "Leave summary report",
        permittedRole: [
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "LEAVE_APPROVAL_STATUS_REPORT",
        label: "Leave approval status report",
        permittedRole: [
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "SICK_LEAVE_APPROVAL_BY_DOCTOR_REPORT",
        label: "Sick leave approval by doctor report",
        permittedRole: [
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "ADVANCE_AMOUNT_REQUEST_REPORT",
        label: "Advance amount request report",
        permittedRole: [
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "EXPENSE_REIMBURSEMENT_REPORT",
        label: "Expense reimbursement report",
        permittedRole: [
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "MEMBER_LEAVE_HISTORY_REPORT",
        label: "Member leave history report",
        permittedRole: [
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "REJECTED_LEAVE_REQUEST_REPORT",
        label: "Rejected leave request report",
        permittedRole: [
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "ON_SEVA_LEAVE_REQUEST_REPORT",
        label: "On seva leave request report",
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
];
export const ROOM_BOOKING_REPORT_TYPE = [
    {
        value: "BOOKED_ROOM_REPORT",
        label: "Booked room report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "ROOMS_AVAILABILITY_REPORT",
        label: "Rooms availability report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "PENDING_REQUESTS_REPORT",
        label: "Pending requests report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },

    {
        value: "CANCELLED_REQUESTS_REPORT",
        label: "Cancelled requests report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "COMPLETED_REQUESTS_REPORT",
        label: "Completed requests report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "LOCATION_WISE_BOOKING_REPORT",
        label: "Location wise booking report",
        permittedRole: [
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    {
        value: "SUMMARY_REPORT",
        label: "Summary report",
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
];
export const FEEDBACK_REPORT_TYPE = [
    {
        value: "FEEDBACK_WISE_MAJOR_AREA_REPORT",
        label: "Feedback wise major area report",
        permittedRole: [
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
        ],
    },
    // {
    //     value: "FEEDBACK_SCORE_WISE_REPORT",
    //     label: "Feedback score wise report",
    //     permittedRole: [
    //         RoutePermittedRole.LOCATION_MANAGER,
    //         RoutePermittedRole.SETUP_MANAGER,
    //         RoutePermittedRole.ADMIN,
    //         RoutePermittedRole.SUPER_ADMIN,
    //     ],
    // },
];
export const BIRTHDAY_REPORT_TYPE = [
    {
        value: "BIRTHDAY_REPORT",
        label: "Birthday report",
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
        ],
    },
];

export const HTTP_STATUS = {
    OK: "OK",
    200: "200",
    300: "300",
    500: "500",
};

export const SUPPORTED_FORMAT_IMAGE = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/apng",
    "image/gif",
    "image/svg+xml",
    "image/webp",
];
export const SUPPORTED_FORMAT_PDF = ["application/pdf"];
export const SUPPORTED_FORMAT_AUDIO = [
    "audio/mpeg",
    "audio/MP3",
    "audio/mp3",
    "audio/WAV",
    "audio/OGG",
];
export const SUPPORTED_FORMAT_DOCS = [
    ".docx",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".doc",
];
export const SUPPORTED_EXCEL_FORMAT = [
    ".xlsx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".xls",
];
export const LEAVE_TYPE_OPTION = [
    { label: "Personal leave", value: "PERSONAL_LEAVE" },
    { label: "Sick leave", value: "SICK_LEAVE" },
    { label: "On Seva", value: "ON_SEVA" },
];
export const LEAVE_TYPE = {
    PERSONAL_LEAVE: "PERSONAL_LEAVE",
    SICK_LEAVE: "SICK_LEAVE",
    ON_SEVA: "ON_SEVA",
};
export const MODE_OF_TRAVEL = [
    { label: "Road", value: "road" },
    { label: "Train", value: "train" },
    { label: "Flight", value: "flight" },
];
export const EXPENSE_TYPE = {
    TRAVEL: "TRAVEL",
    FOOD: "FOOD",
    HOTEL: "HOTEL",
    OTHER: "OTHER",
};
export const REQUEST_ACTIONS = {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    CONCERNED: "CONCERNED",
    REIMBURSED: "REIMBURSED",
};
export const STATUS_CODE = {
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    CONCERNED: "CONCERNED",
    CANCELLED: "CANCELLED",
    COMPLETED: "COMPLETED",
    REIMBURSED: "REIMBURSED",
    PENDING_WITH_DOCTOR: "PENDING_WITH_DOCTOR",
    PENDING_WITH_RM: "PENDING_WITH_PS",
    PENDING_WITH_FINANCE: "PENDING_WITH_FINANCE",
    PENDING_WITH_HR: "PENDING_WITH_HR",
    PENDING_WITH_ADMIN: "PENDING_WITH_ADMIN",
    APPROVED_BY_DOCTOR: "APPROVED_BY_DOCTOR",
};
export const WASHROOM_TYPE = [
    {
        name: "Indian",
    },
    {
        name: "Western",
    },
    {
        name: "Both",
    },
    {
        name: "Common",
    },
];
export const ROOM_TYPE = [
    {
        name: "Guest Room",
    },
    {
        name: "Dhamwasi",
    },
    {
        name: "SPL SEVAK",
    },
    {
        name: "YOUTH",
    },
    {
        name: "Youth/Satsangee",
    },
    {
        name: "Satsangee Room",
    },
];
// issues
export const PRIORITY = [
    {
        name: "Low",
    },
    {
        name: "Medium ",
    },
    {
        name: "High ",
    },
];
export const statusList = [
    {
        name: "active",
    },
    {
        name: "inActive ",
    },
];
export const taskStatusList = [
    {
        key: "NOT_STARTED",
        label: "Not Started",
    },
    {
        key: "IN_PROGRESS",
        label: "In Progress",
    },
    {
        key: "COMPLETED",
        label: "Completed",
    },
    {
        key: "DELAY",
        label: "Delay",
    },
];
// export const MEMBER_TYPE = [
//     { label: "Member", value: "MEMBER" },
//     { label: "Non Member", value: "NON_MEMBER" },
// ];
export const ITEM_LIMIT = 10;
export const satsangeeCategory = [
    {
        key: "MEMBER",
        label: "Member",
    },
    {
        key: "NON_MEMBER",
        label: "Non Member ",
    },
];
export const sevaTypeList = [
    {
        key: "KUNJ_BOOKING",
        label: "Kunj Booking",
    },
    {
        key: "JSS_SEVA",
        label: "JSS Seva",
    },
    {
        key: "PROJECT_SEVA",
        label: "Project Seva",
    },
    {
        key: "IN_EVENT_SEVA",
        label: "In Event Seva",
    },
    {
        key: "UNIT_TOUR_SEVA",
        label: "Unit Tour Seva",
    },
];
export const unitCategoryList = [
    {
        key: "A",
        label: "A",
    },
    {
        key: "B ",
        label: " B ",
    },
    {
        key: "OTHER_TEXT",
        label: "Other text",
    },
];
export const satsangeeCategoryList = [
    {
        key: "A",
        label: "A",
    },
    {
        key: "B ",
        label: " B ",
    },
    {
        key: "C",
        label: "C",
    },
    {
        key: "D ",
        label: " D ",
    },
    {
        key: "E",
        label: "E",
    },
];
export const objDurationList = [
    {
        key: "QUARTERLY",
        label: "Quarterly",
    },
    {
        key: "YEARLY ",
        label: " Yearly ",
    },
];
export const FEEDBACK_OPTIONS = [
    "Strongly Agree",
    "Agree",
    "Neutral",
    "Disagree",
    "Strongly Disagree",
];

export const USER_TYPE = [
    {
        key: "MEMBER",
        label: "Member",
    },
    {
        key: "NON_MEMBER",
        label: "Non Member",
    },
];

export const OPTION_YES_NO = [
    {
        key: "YES",
        label: "Yes",
    },
    {
        key: "NO",
        label: "No",
    },
];
export const MEMBER_TYPE = [
    {
        name: "MEMBER",
    },
    {
        name: "MANAGER",
    },
    {
        name: "HR-MANAGER",
    },
    {
        name: "FINANCE-MANAGER",
    },
    {
        name: "SETUP-MANAGER",
    },
];
